import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createHouseSaleTicket } from "../api/tickets";
import { useAuth } from "../context/AuthContext";
import { getCurrentSalonId } from "../utils/currentSalon";

export default function HouseSaleRoute() {
  const navigate = useNavigate();
  const didCreateRef = useRef(false);
  const isMountedRef = useRef(false);
  const [isCreating, setIsCreating] = useState(true);
  const { user } = useAuth();
  const salonId =
    getCurrentSalonId(user) ||
    (typeof window !== "undefined"
      ? Number(window.localStorage.getItem("salon_id")) || null
      : null);

  useEffect(() => {
    isMountedRef.current = true;
    if (!salonId) {
      return () => {
        isMountedRef.current = false;
      };
    }
    if (didCreateRef.current) {
      return () => {
        isMountedRef.current = false;
      };
    }
    didCreateRef.current = true;

    const createTicket = async () => {
      try {
        const payload = salonId ? { salon_id: salonId } : {};
        const ticket = await createHouseSaleTicket(payload);
        if (!isMountedRef.current) return;
        setIsCreating(false);
        if (ticket?.id) {
          navigate(`/tickets/${ticket.id}`, { replace: true });
          return;
        }
        window.alert("Unable to create house sale ticket.");
        navigate("/tickets", { replace: true });
      } catch (err) {
        if (!isMountedRef.current) return;
        setIsCreating(false);
        const detail = err?.response?.data?.detail;
        const message = typeof detail === "string" ? detail : err?.message;
        window.alert(message || "Unable to create house sale ticket.");
        navigate("/tickets", { replace: true });
      }
    };

    createTicket();
    return () => {
      isMountedRef.current = false;
    };
  }, [navigate, salonId]);

  if (!isCreating) return null;
  return (
    <div className="px-4 py-6 text-sm text-slate-500">
      Creating house sale ticket...
    </div>
  );
}
